import { useEffect } from 'react';

interface Props {
  title: string;
  description: string;
  /** Absolute canonical URL, e.g. https://dendo.dev or https://dendo.dev/article/42 */
  url?: string;
  /** og:type — defaults to 'website' */
  type?: 'website' | 'article';
  /** og:locale in underscore format, e.g. 'en_US' or 'sk_SK' */
  locale?: string;
}

const OG_IMAGE = 'https://dendo.dev/og-image.png';

const getMeta = (attrName: 'name' | 'property', attrValue: string): HTMLMetaElement => {
  const existing = document.querySelector<HTMLMetaElement>(`meta[${attrName}="${attrValue}"]`);
  if (existing) return existing;

  const el = document.createElement('meta');
  el.setAttribute(attrName, attrValue);
  document.head.appendChild(el);
  return el;
};

const MetaTags = ({ title, description, url = window.location.href, type = 'website', locale = 'en_US' }: Props) => {
  useEffect(() => {
    document.title = title;

    getMeta('name', 'description').content = description;

    getMeta('property', 'og:type').content = type;
    getMeta('property', 'og:url').content = url;
    getMeta('property', 'og:title').content = title;
    getMeta('property', 'og:description').content = description;
    getMeta('property', 'og:image').content = OG_IMAGE;
    getMeta('property', 'og:locale').content = locale;
  }, [title, description, url, type, locale]);

  return null;
};

export default MetaTags;
